import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { ServiceIcons } from "@monorepo/components";
import theme from "@monorepo/styles/theme";
import { IService } from "@monorepo/types";
import { Box, ListItem, Typography } from "@mui/material";

interface IFilteredServicesList {
  services: Array<IService>;
  pathToPush: (id: string) => string;
}

const FilteredServicesList: React.FC<IFilteredServicesList> = ({ services, pathToPush }) => {
  const history = useHistory();
  const { t } = useTranslation();
  return (
    <>
      <Typography textAlign="center" variant="body1" component="span">
        {t("servicesList.choose_service")}
      </Typography>
      <Box>
        {services?.map(({ id, api_service_name: apiServiceName, category_id: categoryId }) => {
          return (
            <ListItem
              sx={{
                display: "flex",
                alignItems: "center",
                columnGap: theme.spacing(2),
                cursor: "pointer",
                padding: "12px",
                borderRadius: "12px",
                backgroundColor: "inherit",
                color: "inherit",
                "&:hover": {
                  color: theme.palette.secondary.main,
                  background: theme.palette.shuttleGray.main,
                },
              }}
              role="presentation"
              tabIndex={-1}
              key={id}
              onClick={() => history.push(pathToPush(id))}
            >
              <ServiceIcons serviceId={categoryId} />
              <Typography component="span">{apiServiceName}</Typography>
            </ListItem>
          );
        })}
      </Box>
    </>
  );
};

export default FilteredServicesList;
